<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <!--<el-dropdown-item-->
          <!--v-if="declutter.status === 'completed' && declutter.receipt_file"-->
          <!--v-can="'declutter.view'"-->
          <!--:command="openReceipt"-->
          <!--:disabled="buttonLoader"-->
        <!--&gt;-->
          <!--<i class="el-icon-printer" /> Bizonylat nyomtatása-->
        <!--</el-dropdown-item>-->
        <el-dropdown-item
          v-if="declutter.status === 'completed'"
          v-can="'declutter.update'"
          :command="cancelDeclutter"
          :disabled="buttonLoader"
        >
          <i class="el-icon-close" /> Selejtezés érvénytelenítése
        </el-dropdown-item>
        <el-dropdown-item
          v-if="declutter.status === 'recorded'"
          v-can="'declutter.update'"
          :command="startDeclutter"
          :disabled="buttonLoader"
        >
          <i class="el-icon-s-promotion" /> Selejtezés indítása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="declutter.status === 'completed' || declutter.status === 'recorded'"
          v-can="'declutter.update'"
          :command="updateDeclutter"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="declutter.status === 'recorded'"
          v-can="'declutter.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['declutter'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteDeclutter() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('declutter/delete', this.declutter.id);
          this.$store.dispatch('declutter/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async updateDeclutter() {
        this.$router.push('/processes/declutters/update/' + this.declutter.id);
      },
      async startDeclutter() {
        this.buttonLoader = true;
        try {
          await axios.post('/api/declutters-cull/' + this.declutter.id);
          this.$store.dispatch('declutter/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async cancelDeclutter() {
        this.buttonLoader = true;
        try {
          await axios.post('api/declutters-cancel/' + this.declutter.id);
          this.$store.dispatch('declutter/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      openReceipt() {
        if (this.declutter.receipt_file && this.declutter.receipt_file.path) {
          window.open(this.declutter.receipt_file.path);
        }
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteDeclutter();
        })
        .catch(() => {
          this.$router.replace('/processes/declutters');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/declutters/' + this.declutter.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'declutter_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },
    }
  };
</script>
